<p>Verifique el emparejamiento de los cursos de <strong>Prime Timetable</strong> con sus equivalentes de <strong>MiGLM</strong>.</p>
<table *ngIf="objetosFiltrados" [formGroup]="form" mat-table [dataSource]="objetosFiltrados" class="full-width mat-elevation-z4">  
    <ng-container matColumnDef="origen">
      <th mat-header-cell *matHeaderCellDef> {{aEmparejar}} en Prime Timetable</th>
      <td mat-cell *matCellDef="let element"> {{element.name + ' ' + element.shortName}} </td>
    </ng-container>
    <ng-container matColumnDef="destino">
      <th mat-header-cell *matHeaderCellDef> {{aEmparejar}} en MiGLM </th>
      <td mat-cell *matCellDef="let element">
        {{element[propiedad].nombre}}
    </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['origen', 'destino']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['origen', 'destino'];"></tr>
  </table>